import script from "./VenueInfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VenueInfoModal.vue?vue&type=script&setup=true&lang=js"

import "./VenueInfoModal.vue?vue&type=style&index=0&id=3a4ba1b9&lang=scss"

const __exports__ = script;

export default __exports__